import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import DashboardLayout from "components/dashboard/DashboardLayout";
import Settings from "components/dashboard/Settings";
import { useAuth } from "hooks/useAuth";
import {
  MorningReportList,
  MorningReportWorkspace,
} from "features/morningReport/MorningReportPages";
import HomePage from "pages/dashboard/HomePage";

/** MorningReport learners: the teaching cases and their settings, nothing else. */
const LearnerRoutes = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  return (
    // Full-bleed like ChartMind; Settings keeps the normal column.
    <DashboardLayout fullWidth={pathname.includes("/morning-report")}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/morning-report" element={<MorningReportList />} />
        <Route
          path="/morning-report/:sessionId"
          element={<MorningReportWorkspace />}
        />
        <Route path="/settings" element={<Settings uid={user?.uid} />} />
        <Route
          path="*"
          element={<Navigate to="/dashboard/morning-report" replace />}
        />
      </Routes>
    </DashboardLayout>
  );
};

export default LearnerRoutes;
